module.exports = __webpack_public_path__ + "img/left_def.532e038d.png";